import { type AlertProps } from "@mui/lab/Alert";
import { Alert as MuiAlert } from "@mui/material";
import React from "react";

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
	function Alert(props, ref) {
		return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
	},
);
